var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"pa-0 ma-0",attrs:{"small":"","icon":"","flat":"","color":_vm.playing ? 'red' : 'primary',"loading":_vm.loadingAudio,"disabled":_vm.inError},on:{"click":_vm.handleClick}},[_c('v-icon',[_vm._v(_vm._s(_vm.inError ? 'error' : (this.playing ? 'stop' : 'play_arrow')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }